import styled from 'styled-components';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import HelpCircleIcon from 'mdi-react/HelpCircleIcon';
import { layout } from '@prisjakt/ui-base';

export const BooleanPropertyValue = styled.div`
  display: flex;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

const BOOLEAN_ICON_SIZE = 16;

export const BooleanTrueIcon = styled(CheckCircleIcon).attrs(({ theme }) => ({
  size: BOOLEAN_ICON_SIZE,
  color: theme.icons.positive,
}))``;

export const BooleanFalseIcon = styled(CloseCircleIcon).attrs(({ theme }) => ({
  size: BOOLEAN_ICON_SIZE,
  color: theme.icons.negative,
}))``;

export const BooleanUnknownIcon = styled(HelpCircleIcon).attrs(({ theme }) => ({
  size: BOOLEAN_ICON_SIZE,
  color: theme.icons.secondary,
}))``;
